import i18n from 'helpers/i18n';
import messages from './messages';
import { Icon } from 'semantic-ui-react';

interface VideoNavigationProps {
  sliderLength: number;
  currentVideoIndex: number | undefined;
  onSelect: (index: number) => void;
}

function VideoNavigation({
  sliderLength,
  currentVideoIndex,
  onSelect
}: VideoNavigationProps) {
  function sliderHasOnePage() {
    return sliderLength <= 1;
  }

  if (sliderHasOnePage()) {
    return null;
  }

  return (
    <div>
      {Array(sliderLength)
        .fill(true)
        .map((_, i) => (
          <button
            key={i}
            type="button"
            className="mr-3 p-1 rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
            aria-label={i18n.ft(messages.goToPage, {
              index: i + 1,
              total: sliderLength
            })}
            aria-current={i === currentVideoIndex ? 'true' : undefined}
            onClick={() => onSelect(i)}
          >
            <Icon
              name="circle"
              size="mini"
              aria-hidden="true"
              style={{ fontSize: '0.6em' }}
              className={`m-0 ${
                i === currentVideoIndex
                  ? 'text-blue-600'
                  : 'text-scale-grey-500'
              }`}
            />
          </button>
        ))}
    </div>
  );
}

export default VideoNavigation;
